import { expandObj } from 'utils/functions'

interface IUseEnvironmentReturn {
  api: {
    read: string
    cdu: string
    login: string
    gst: string
  }
  environment: string
  allowLogger: boolean
  website_url: string
  isHomolog: boolean
}

const environments = expandObj({
  '3161, 3161, 1917': 'hom',
  'homolog-portal-ngt': 'hom',
  '6293, 3771': 'qa_csn'
})

const useEnvironment = (): IUseEnvironmentReturn => {
  const API_READ = process.env.REACT_APP_API_READ_URL
  const API_CDU = process.env.REACT_APP_API_CDU_URL
  const API_LOGIN = process.env.REACT_APP_API_LOGIN_URL
  const API_GST = process.env.REACT_APP_API_GST_URL

  const LOCATION_URL = window.location.href.substring(
    0,
    window.location.href.indexOf('#') + 1
  )

  const getEnvironmentName = (): string => {
    const environmentkeys = Object.keys(environments)

    return environments[
      [API_READ, API_CDU, API_LOGIN, API_GST]
        .join(' ')
        .match(new RegExp(environmentkeys.join('|')))[0]
    ]
  }

  return {
    allowLogger: eval(process.env.REACT_APP_ALLOW_LOGGER),
    api: {
      cdu: API_CDU,
      login: API_LOGIN,
      read: API_READ,
      gst: API_GST
    },
    environment: 'hom',
    isHomolog: true,
    website_url: LOCATION_URL
  }
}

export default useEnvironment
